// extracted by mini-css-extract-plugin
module.exports = {"root":"Select_root__RWQCx","buttonContainer":"Select_buttonContainer__2WAS1","error":"Select_error__z6uzW","label":"Select_label__3GQTL","errorText":"Select_errorText__1ZiFj"};